import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { PRICER_RISK_VIEWS, resolvePricerRiskView } from "../resolvePricerView";
import DetailHealth from "./Health";
import DetailRateLookup from "./RateLookup";
import DetailService from "./Service";
import DetailTerminal from "./Terminal";

const VIEW_BY_KEY = {
  [PRICER_RISK_VIEWS.health]: DetailHealth,
  [PRICER_RISK_VIEWS.terminal]: DetailTerminal,
  [PRICER_RISK_VIEWS.service]: DetailService,
  [PRICER_RISK_VIEWS.rateLookup]: DetailRateLookup,
};

const Detail = (props) => {
  const { state } = useLocation();
  const risk = state && state.risk;
  const View = useMemo(() => VIEW_BY_KEY[resolvePricerRiskView(risk)], [risk]);
  return <View {...props} />;
};

export default Detail;
